module.exports = __webpack_public_path__ + "media/images/ui-light-47a71213.jpg";